import { Component, HostListener, inject } from '@angular/core';
import Keycloak from 'keycloak-js';

@Component({
  selector: 'app-avatar',
  imports: [],
  templateUrl: './avatar.html',
  styleUrl: './avatar.scss',
})
export class Avatar {
  isMenuOpen = false;
  private keyCloak = inject(Keycloak);
  userName = '';

  async toggleMenu(event: MouseEvent) {
    const user = await this.keyCloak.loadUserProfile();
    this.userName = `${user.firstName} ${user.lastName}`;
    event.preventDefault(); // Evita menu nativo do navegador
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu() {
    this.isMenuOpen = false;
  }

  // Fecha o menu ao clicar fora
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.avatar-container')) {
      this.closeMenu();
    }
  }

  logout() {
    this.keyCloak.logout();
  }
}
